const Blog = () => {
  return <div>Blog page</div>;
};

export default Blog;
